import * as React from 'react';

import {Url} from 'shells/entity/entity-display-values/url';

import styles from './cell.module.css';

type Props = {
    value?: {
        value: string;
        url: string;
        isHidden?: boolean;
    };
};

export function CellUrl(props: Props) {
    let displayValue, urlValue, isHidden;
    if (props.value) {
        displayValue = props.value.value;
        urlValue = props.value.url;
        isHidden = props.value.isHidden;
    }

    return (
        <div title={isHidden ? undefined : urlValue} className={styles['cell-content']}>
            {displayValue ? <Url value={props.value} /> : undefined}
        </div>
    );
}
